import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles({
    amazonCLIContainer: {
        overflowX: 'scroll',
    },
});

function amazonCliServerTable() {
    const classes = styles();
    return (
        <div className={classes.amazonCLIContainer}>
            <table>
                <thead>
                    <tr>
                        <th>Amazon Bucket Location</th>
                        <th>Signiant Flight Server</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>US East 1 (N. Virginia)</td>
                        <td>us-east-1-am.cloud.signiant.com</td>
                    </tr>
                    <tr>
                        <td>US West 2 (Oregon)</td>
                        <td>us-west-2-am.cloud.signiant.com</td>
                    </tr>
                    <tr>
                        <td>Europe (Ireland)</td>
                        <td>eu-west-1-am.cloud.signiant.com</td>
                    </tr>
                    <tr>
                        <td>Europe (Frankfurt)</td>
                        <td>eu-central-1-am.cloud.signiant.com</td>
                    </tr>
                    <tr>
                        <td>Asia Pacific (Singapore)</td>
                        <td>ap-southeast-1-am.cloud.signiant.com</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

amazonCliServerTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default amazonCliServerTable;
